import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	modal: {
		maxWidth: 400,
	},
});
